// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5366":"fff9a0b4","6958":"fff9a0b4"}[chunkId] + ".chunk.css";
};